@if (legacyLea2WorkforceEnabled$ | async) {
  <ul class="navbar-nav flex-grow">
    <li class="nav-item dropdown my-auto">
      <a
        class="nav-link dropdown-toggle"
        [routerLink]="['/lea2']"
        [routerLinkActive]="['link-active']"
        role="button"
        data-bs-toggle="dropdown"
        aria-expanded="false"
      >
        Staff
        @if (pendingPDRequestsCount() > 0 && complexProfessionalDevelopmentEnabled()) {
          <span
            class="badge rounded-pill bg-danger text-white position-relative"
            style="top: -6px; left: 2px; font-size: 0.65rem; min-width: 1.25rem"
          >
            {{ pendingPDRequestsCount() }}
          </span>
        }
      </a>
      <ul class="dropdown-menu dropdown-menu-left">
        <li *componentRequiresPolicy="'canViewLeaCredentialManagementRoster'">
          <a
            class="dropdown-item"
            [routerLinkActive]="['link-active']"
            [routerLink]="['/lea2/staff/credential-management-roster']"
          >
            Credential Management Roster
          </a>
        </li>
        @if (workforceManagementEnabled$ | async) {
          <li *componentRequiresPolicy="'canViewLeaWorkforceInformation'">
            <a class="dropdown-item" [routerLinkActive]="['link-active']" [routerLink]="['/lea2/workforce-management']">
              Workforce Management
            </a>
          </li>
        }
        <li *componentRequiresPolicy="'canViewLeaWorkforceInformation'">
          <a class="dropdown-item" [routerLinkActive]="['link-active']" [routerLink]="['/lea2/staff/roster']">
            Workforce Roster
          </a>
        </li>
        <li *componentRequiresPolicy="'canViewLeaWorkforceInformation'">
          <a class="dropdown-item" [routerLinkActive]="['link-active']" [routerLink]="['/lea2/staff/positions']">
            Position
          </a>
        </li>
        <li *componentRequiresAllPolicies="['canViewLeaWorkforceInformation', 'canViewPerformanceEvaluations']">
          <a
            class="dropdown-item"
            [routerLinkActive]="['link-active']"
            [routerLink]="['/lea2/performance-evaluations']"
          >
            Evaluations
          </a>
        </li>
        <li *componentRequiresPolicy="'canViewLeaWorkforceInformation'">
          <a
            class="dropdown-item"
            [routerLinkActive]="['link-active']"
            [routerLink]="['/lea2/staff/roster/historical-snapshot']"
          >
            Historical Snapshot
          </a>
        </li>
        @if (complexProfessionalDevelopmentEnabled()) {
          <li *componentRequiresPolicy="'canVerifyProfessionalDevelopment'">
            <a
              class="dropdown-item"
              [routerLinkActive]="['link-active']"
              [routerLink]="['/lea2/staff/professional-development']"
            >
              Professional Development
              @if (pendingPDRequestsCount() > 0) {
                <span
                  class="badge rounded-pill bg-danger text-white position-relative"
                  style="top: -6px; left: 2px; font-size: 0.65rem; min-width: 1.25rem"
                >
                  {{ pendingPDRequestsCount() }}
                </span>
              }
            </a>
          </li>
        }
      </ul>
    </li>
    <li class="nav-item dropdown my-auto" *componentRequiresPolicy="'canViewLeaWorkforceInformation'">
      <a class="nav-link dropdown-toggle" role="button" data-bs-toggle="dropdown" aria-expanded="false">Programs</a>
      <ul class="dropdown-menu dropdown-menu-left">
        <li>
          <a class="dropdown-item" [routerLinkActive]="['link-active']" [routerLink]="['/lea2/title-1/']"> Title I </a>
        </li>
        @if (vouchersEnabled$ | async) {
          <li *componentRequiresPolicy="'canManageLeaVoucherCredits'">
            <a class="dropdown-item" [routerLink]="['/lea2/vouchers']" [routerLinkActive]="['link-active']">
              Vouchers
            </a>
          </li>
        }
      </ul>
    </li>
    <li class="nav-item dropdown my-auto" *componentRequiresPolicy="'canViewLeaWorkforceInformation'">
      <a class="nav-link dropdown-toggle" role="button" data-bs-toggle="dropdown" aria-expanded="false">Engagement</a>
      <ul class="dropdown-menu dropdown-menu-left">
        <li *componentRequiresPolicy="'canViewLeaSurveys'">
          <a class="dropdown-item" [routerLinkActive]="['link-active']" [routerLink]="['/lea2/surveys-and-polls']">
            Surveys
          </a>
        </li>
        <li>
          <a class="dropdown-item" [routerLinkActive]="['link-active']" [routerLink]="['/lea2/contacts']"> Contacts </a>
        </li>
      </ul>
    </li>
    @if (canManageLeaUploads || canManageLeaStaffRoster) {
      <li class="nav-item dropdown my-auto" *componentRequiresPolicy="'canViewLeaWorkforceInformation'">
        <a class="nav-link dropdown-toggle" role="button" data-bs-toggle="dropdown" aria-expanded="false">Data</a>
        <ul class="dropdown-menu dropdown-menu-left">
          <li *componentRequiresPolicy="'canManageLeaUploads'">
            <a class="dropdown-item" [routerLinkActive]="['link-active']" [routerLink]="['/lea2/batch-upload']">
              Batch Upload
            </a>
          </li>
          <li *componentRequiresPolicy="'canManageLeaStaffRoster'">
            <a class="dropdown-item" [routerLinkActive]="['link-active']" [routerLink]="['/lea2/staff/reconciliation']">
              Reconciliation
            </a>
          </li>
        </ul>
      </li>
    }
    <li class="nav-item">
      <a
        class="nav-link clickable"
        [routerLink]="['/lea2/reports']"
        [routerLinkActive]="['link-active']"
        role="button"
        aria-expanded="false"
        >Reports</a
      >
    </li>
    <li class="nav-item">
      <a
        class="nav-link clickable"
        [routerLink]="['/lea2/help']"
        [routerLinkActive]="['link-active']"
        role="button"
        aria-expanded="false"
        >Help</a
      >
    </li>
  </ul>
} @else {
  <ul class="navbar-nav flex-grow nav-described">
    <li class="nav-item dropdown my-auto" *componentRequiresPolicy="'canViewLeaCredentialManagementRoster'">
      <a class="nav-link dropdown-toggle" role="button" data-bs-toggle="dropdown" aria-expanded="false">
        Educator Credentials
        @if (pendingPDRequestsCount() > 0 && complexProfessionalDevelopmentEnabled()) {
          <span class="badge badge-danger ms-1">{{ pendingPDRequestsCount() }}</span>
        }
      </a>
      <ul class="dropdown-menu dropdown-menu-left">
        <li *componentRequiresPolicy="'canViewLeaCredentialManagementRoster'">
          <a
            class="dropdown-item text-wrap"
            [routerLinkActive]="['link-active']"
            [routerLink]="['/lea2/staff/credential-management-roster']"
          >
            Credential Management Roster
            <small class="d-block text-muted">Manage and monitor educator credential status and requirements</small>
          </a>
        </li>
        @if (complexProfessionalDevelopmentEnabled()) {
          <li *componentRequiresPolicy="'canVerifyProfessionalDevelopment'">
            <a
              class="dropdown-item text-wrap"
              [routerLinkActive]="['link-active']"
              [routerLink]="['/lea2/staff/professional-development']"
            >
              Professional Development
              @if (pendingPDRequestsCount() > 0) {
                <span class="badge badge-danger ms-1">{{ pendingPDRequestsCount() }}</span>
              }
              <small class="d-block text-muted">Manage credential-related professional development</small>
            </a>
          </li>
        }
        @if (vouchersEnabled$ | async) {
          <li *componentRequiresPolicy="'canManageLeaVoucherCredits'">
            <a class="dropdown-item text-wrap" [routerLink]="['/lea2/vouchers']" [routerLinkActive]="['link-active']">
              Vouchers
              <small class="d-block text-muted">Provide educators credential-related fee vouchers</small>
            </a>
          </li>
        }
      </ul>
    </li>
    <li class="nav-item dropdown my-auto" *componentRequiresPolicy="'canViewLeaWorkforceInformation'">
      <a class="nav-link dropdown-toggle" role="button" data-bs-toggle="dropdown" aria-expanded="false">Workforce</a>
      <ul class="dropdown-menu dropdown-menu-left">
        <li><span class="dropdown-header text-uppercase">LEA Information</span></li>
        <li>
          <a class="dropdown-item text-wrap" [routerLinkActive]="['link-active']" [routerLink]="['/lea2/contacts']">
            Contacts
            <small class="d-block text-muted">Report required LEA and Site Principal contacts</small>
          </a>
        </li>
        <li>
          <a class="dropdown-item text-wrap" [routerLinkActive]="['link-active']" [routerLink]="['/lea2/title-1/']">
            Title I Site Information
            <small class="d-block text-muted">Report required Title I Site Information</small>
          </a>
        </li>
        <li><hr class="dropdown-divider" /></li>
        <li><span class="dropdown-header text-uppercase">Workforce Management</span></li>
        @if (workforceManagementEnabled$ | async) {
          <li>
            <a
              class="dropdown-item text-wrap"
              [routerLinkActive]="['link-active']"
              [routerLink]="['/lea2/workforce-management']"
            >
              Workforce Management
              <small class="d-block text-muted"> Report and manage staff employment, assignments, and positions </small>
            </a>
          </li>
        }
        <li *componentRequiresAllPolicies="['canViewLeaWorkforceInformation', 'canViewPerformanceEvaluations']">
          <a
            class="dropdown-item text-wrap"
            [routerLinkActive]="['link-active']"
            [routerLink]="['/lea2/performance-evaluations']"
          >
            Teacher and Principal Evaluations
            <small class="d-block text-muted">Upload or manage Teacher and Principal evaluation information</small>
          </a>
        </li>
      </ul>
    </li>
    <li class="nav-item dropdown my-auto" *componentRequiresPolicy="'canViewLeaSurveys'">
      <a class="nav-link dropdown-toggle" role="button" data-bs-toggle="dropdown" aria-expanded="false">Surveys</a>
      <ul class="dropdown-menu dropdown-menu-left">
        <li>
          <a
            class="dropdown-item text-wrap"
            [routerLinkActive]="['link-active']"
            [routerLink]="['/lea2/surveys-and-polls']"
          >
            Surveys
            <small class="d-block text-muted">Complete required surveys</small>
          </a>
        </li>
      </ul>
    </li>
    <li class="nav-item">
      <a class="nav-link clickable" [routerLink]="['/lea2/reports']" [routerLinkActive]="['link-active']">Reports</a>
    </li>
    <li class="nav-item">
      <a class="nav-link clickable" [routerLink]="['/lea2/help']" [routerLinkActive]="['link-active']">Help</a>
    </li>
  </ul>
}
